import { Navigation } from './navigation';

class Header {
	navigations = [];
	constructor($el) {
		this.$el = $el;
		this.$navigations = this.$el.find('[data-nav="el"]');

		this.init();
	}

	init = () => {
		this.$navigations.each((i, el) => {
			const navigation = new Navigation($(el));
			this.navigations.push(navigation);
		});
	};

	handleActiveClass = id => {
		this.navigations.forEach(navigation => {
			navigation.setActiveLink(id);
		});
	};
}

export { Header };
